<div fxLayout="column" style="padding:15px;">

    <app-page-header [title]="pageTitle" action=''></app-page-header>

    <div fxLayout="column" fxFlex="grow" fxLayoutAlign="center center center" style="margin-top:50px;">
        <div fxLayout="row" style="width:80%">
            <mat-table [dataSource]="pendingUsers" style="width: 100%;">

                <ng-container matColumnDef="id">
                    <mat-header-cell *matHeaderCellDef fxLayoutAlign="start center center">Α/Α</mat-header-cell>
                    <mat-cell *matCellDef="let user"
                              fxLayoutAlign="start center center"> {{user.id}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="user_id">
                    <mat-header-cell *matHeaderCellDef fxLayoutAlign="start center center">Id</mat-header-cell>
                    <mat-cell *matCellDef="let user"
                              fxLayoutAlign="start center center"> {{user.user_id}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="user_college_id">
                    <mat-header-cell *matHeaderCellDef fxLayoutAlign="start center center">Contact Id</mat-header-cell>
                    <mat-cell *matCellDef="let user"
                              fxLayoutAlign="start center center"> {{user.user_college_id}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="first_name">
                    <mat-header-cell *matHeaderCellDef fxLayoutAlign="start center center">Όνομα</mat-header-cell>
                    <mat-cell *matCellDef="let user"
                              fxLayoutAlign="start center center"> {{user.first_name}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="last_name">
                    <mat-header-cell *matHeaderCellDef fxLayoutAlign="start center center">Επώνυμο</mat-header-cell>
                    <mat-cell *matCellDef="let user"
                              fxLayoutAlign="start center center"> {{user.last_name}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="user_email">
                    <mat-header-cell *matHeaderCellDef fxLayoutAlign="start center center">Email</mat-header-cell>
                    <mat-cell *matCellDef="let user"
                              fxLayoutAlign="start center center"> {{user.user_email}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="user_telephone">
                    <mat-header-cell *matHeaderCellDef fxLayoutAlign="start center center">Τηλέφωνο</mat-header-cell>
                    <mat-cell *matCellDef="let user"
                              fxLayoutAlign="start center center"> {{user.user_telephone}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef fxLayoutAlign="start center center"> Ενέργειες</mat-header-cell>
                    <mat-cell *matCellDef="let user"
                              fxLayoutAlign="start center center">
                        <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"
                             style="cursor: pointer; align-content: center;">
                            <div fxLayout="row" fxFlexAlign="center">
                                <mat-icon style="align-content:center; vertical-align: middle; color:var(--primary)">
                                    {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}
                                </mat-icon>
                            </div>
                        </div>

                        <mat-menu #menu="matMenu">
                            <mat-list>
                                <mat-list-item class="menuList">
                                    <button mat-menu-item (click)="activateUser(user)">
                                        <mat-icon class="icon">info</mat-icon>&nbsp;Ενεργοποίηση χρήστη
                                    </button>
                                </mat-list-item>
<!--                                <mat-list-item class="menuList">-->
<!--                                    <button mat-menu-item (click)="sendEmail(user)">-->
<!--                                        <mat-icon class="icon">email</mat-icon>&nbsp;Αποστολή email-->
<!--                                    </button>-->
<!--                                </mat-list-item>-->
                            </mat-list>
                        </mat-menu>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let record; columns: columnsToDisplay"></mat-row>
            </mat-table>
        </div>

        <div *ngIf="loading">
            <app-loading></app-loading>
        </div>

        <div *ngIf="pendingUsers.data.length === 0 && !loading">
            <div fxLayoutAlign="center center center" style="margin-top: 50px; margin-bottom: 50px;">
                Δεν υπάρχουν εκκρεμείς χρήστες
            </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="end center center" style="margin-top:5px;">
            <mat-paginator [length]="pendingUsers.data.length" [pageSize]="5" [pageSizeOptions]="[5, 20, 50, 100]">
            </mat-paginator>
        </div>
    </div>
</div>
